// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5e1b8303","453":"6439e070"}[chunkId] + ".chunk.js";
};